document.addEventListener('DOMContentLoaded', () => {

  const modalTabela = document.querySelector('.modal-tabela');

  if (!modalTabela) return;

  const botoesTabela = document.querySelectorAll('.btn-tabelas-medidas');
  const closeIcon = modalTabela.querySelector('.close-icon');
  const shadow = modalTabela.querySelector('.shadow');

  botoesTabela.forEach((botao) => {

    botao.addEventListener('click', () => {
      modalTabela.classList.add('active');
    });

  });

  if (closeIcon) {
    closeIcon.addEventListener('click', () => {
      modalTabela.classList.remove('active');
    });
  }

  if (shadow) {
    shadow.addEventListener('click', () => {
      modalTabela.classList.remove('active');
    });
  }

});